<template>
  <v-container class="pt-6 pb-2">
    <!-- datos cuenta usuario -->
    <v-row>
      <v-card width="100%" color="orange lighten-4" class="mb-2" elevation="1">
        <v-card-text>
          <!-- eslint-disable-next-line prettier/prettier -->
          <div class="overline font-weight-bold mb-1">{{ t.auth.datosUsuario }}</div>
          <v-row no-gutters>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="4"><pre class="text-truncate">{{ t.auth.nombre }}</pre></v-col>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="8"><pre class="text-truncate">{{ userName }}</pre></v-col>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="4"><pre class="text-truncate">E-mail</pre></v-col>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="8"><pre class="text-truncate">{{ userEmail }}</pre></v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <!-- datos licencia -->
    <v-row>
      <v-card width="100%" color="cyan lighten-4" elevation="1">
        <v-card-text>
          <div class="overline mb-1">
            <v-icon left>card_membership</v-icon>
            <span class="font-weight-bold">{{ t.auth.datosPlan }}</span>
          </div>
          <v-row no-gutters>
            <v-col cols="4">
              <pre>{{ t.auth.tipo }}</pre>
            </v-col>
            <v-col cols="8">
              <pre class="text-truncate">{{ licencia.tipo }}</pre>
            </v-col>
            <v-col cols="4">
              <pre>{{ t.auth.estado }}</pre>
            </v-col>
            <v-col cols="8">
              <pre class="text-truncate">{{ licencia.sta }}</pre>
            </v-col>
            <v-col cols="4">
              <pre>{{ t.auth.activada }}</pre>
            </v-col>
            <v-col cols="8">
              <pre class="text-truncate">{{ licencia.ini }}</pre>
            </v-col>
            <v-col cols="4">
              <pre>{{ t.auth.caduca }}</pre>
            </v-col>
            <v-col cols="8">
              <pre class="text-truncate">{{ licencia.fin }}</pre>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "user-cuenta",
  props: ["enum", "licencia", "userData"],
  computed: {
    userAuth() {
      return this.$store.getters["user/auth"];
    },
    rules() {
      // let _this = this;
      return {
        required: value => !!value || "Se complica todo",
        counter: value => value.length <= 35 || "35 caracteres máximo.",
        selectOne: value => !!value || "Elija una opción.",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "E-mail incorrecto.";
        }
      };
    },
    t() {
      return this.$store.getters["app/trad/activa"];
    },
    userName() {
      return this.userAuth.uid === "__"
        ? this.t.auth.userInvitado
        : this.userAuth.name;
    },
    userEmail() {
      return this.userAuth.uid === "__"
        ? this.t.auth.pendienteAct
        : this.userAuth.email;
    }
  },
  methods: {
    signInGoogle() {
      // https://firebase.google.com/docs/auth/web/google-signin
      // this.$fb.auth().signInWithPopup(this.fb.provGoogle)
      this.$fb
        .auth()
        .signInWithRedirect(this.$fb.provGoogle)
        .catch(e => {
          this.$store.dispatch("app/saveErrorReport", {
            e: e,
            line: 38,
            src: "mdd-login"
          });
        });
    }
  }
};
// Iconos diseñados por <a href="https://www.flaticon.es/autores/freepik" title="Freepik">Freepik</a> from <a href="https://www.flaticon.es/" title="Flaticon"> www.flaticon.es</a>
// Iconos diseñados por <a href="https://www.flaticon.es/autores/pixel-perfect" title="Pixel perfect">Pixel perfect</a> from <a href="https://www.flaticon.es/" title="Flaticon"> www.flaticon.es</a>
</script>

<style>
.enum {
  font-size: 1.5em;
}
</style>
